// extracted by mini-css-extract-plugin
module.exports = {"loading":"dot-loading_loading__1rGNJ","dot-windmill":"dot-loading_dot-windmill__3-dmw"};